import moment from 'moment';
import React from 'react';

import useTranslation from '@/Hooks/UseTranslation';
import RestrictionRowItem from './RestrictionRowItem';

interface TableRowId {
  id: string;
  description: string;
  checked: boolean;
  itemId: string
  taskId: string
  taskName: string
  taskReleasesAt: string
  createdAt: string
  updatedAt: string
  creator: string
  responsible?: any
  responsibles?: any[]
  days: number
}

interface RestrictionTableProps {
  loadStatus: any;
  emptyMessage?: string;
  restrictions: any[]
  sortedColumn: keyof TableRowId
  sortOrder: 'asc' | 'desc'
  onSortByColumn: (column: keyof TableRowId) => void
}

const RestrictionsTable = (props: RestrictionTableProps) => {

  const { loadStatus, restrictions, sortedColumn, sortOrder, onSortByColumn } = props;

  const { t } = useTranslation()

  return (
    <table className="table card-table table-resources-restrictions">
      <thead>
        <tr>
          <th>
            {t('RESOURCES_RESTRICTIONS:ListPositionColumn')}
          </th>
          <th
            className="text-rigth clickable"
            onClick={() => onSortByColumn('description')}
          >
            {t('RESOURCES_RESTRICTIONS:ListRestrictionColumn')} ⇅
            {sortedColumn === 'description' && (
              <span>{sortOrder === 'asc' ? ' ▲' : ' ▼'}</span>
            )}
          </th>
          <th
            className="text-rigth clickable"
            onClick={() => onSortByColumn('createdAt')}
            style={{ width: 150 }}
          >
            {t('RESOURCES_RESTRICTIONS:ListCreatedAtColumn')} ⇅
            {sortedColumn === 'createdAt' && (
              <span>{sortOrder === 'asc' ? ' ▲' : ' ▼'}</span>
            )}
          </th>
          <th
            className="clickable"
            onClick={() => onSortByColumn('creator')}
          >
            {t('RESOURCES_RESTRICTIONS:ListCreatorColumn')} ⇅
            {sortedColumn === 'creator' && (
              <span>{sortOrder === 'asc' ? ' ▲' : ' ▼'}</span>
            )}
          </th>
          <th>{t('RESOURCES_RESTRICTIONS:ListResponsibleColumn')}</th>
          <th style={{ width: 150 }}>
            {t('RESOURCES_RESTRICTIONS:ListPromiseDateColumn')}
          </th>
          <th style={{ width: 150 }}>
            {t('RESOURCES_RESTRICTIONS:ListRequiredDateColumn')}
          </th>
          <th style={{ width: 150 }}>
            {t('RESOURCES_RESTRICTIONS:ListReleaseDateColumn')}
          </th>
          <th style={{ width: 150 }}>
            {t('RESOURCES_RESTRICTIONS:ListCloseDateColumn')}
          </th>
          <th style={{ width: 150 }}>
            {t('RESOURCES_RESTRICTIONS:ListDaysOpenColumn')}
          </th>
        </tr>
      </thead>
      <tbody>
        {!restrictions.length && loadStatus === 'loading' && (
          <tr>
            <td colSpan={10} className="pl4-restrictions-table-message">{t('RESOURCES_RESTRICTIONS:ListLoading')}</td>
          </tr>
        )}
        {!restrictions.length && loadStatus === 'loaded' && (
          <tr>
            <td colSpan={10} className="pl4-restrictions-table-message">
              {props.emptyMessage || t('RESOURCES_RESTRICTIONS:ListNoOpenRestrictions')}
            </td>
          </tr>
        )}
        {restrictions.map((row, index) => (
          <RestrictionRowItem
            key={index}
            item={row}
          />
        ))}
      </tbody>
    </table>
  );
};

export default RestrictionsTable;
